<template>
    <v-layout column class="language-page px-3">
      <v-card class="language-card align-center justify-center" flat light>
        <v-card-title class="language-card__title prompt-header">
          <mrx-translation :token="prompt"></mrx-translation>
        </v-card-title>

      <multiselect
        v-model="languages"
        class="language-options"
        panel-name="language"
        panel-type="select"
        :on-click="selectLanguage"
        :embedded="isInitialSetup"
      />
      </v-card>
    </v-layout>
</template>

<script>
  import MultiSelect from '@/components/inputs/MultiSelect';
  import { mapActions, mapState } from 'pinia'
  import { useLanguageStore } from '@/stores/language';
  import { useNavigation } from '@/composables/useNavigation';

  export default {
    name: 'Language',
    components: {
      multiselect: MultiSelect,
    },
    setup() {
      const { next } = useNavigation();
      return { next };
    },
    data() {
      return {
        prompt: 'questions.language.prompt'
      }
    },
    computed: {
      isInitialSetup() {
        return this.$route.query.setup === 'true';
      },
      languages() {
        return this.all.map(language => ({
          selected: language.value === this.selected,
          ...language,
        }));
      },
      ...mapState(useLanguageStore, ['all', 'selected'])
    },
    methods: {
      selectLanguage(value) {
        this.set(value);
        if (this.isInitialSetup) this.next();
      },
      ...mapActions(useLanguageStore, ['set'])
    },
  }
</script>

<style src="./styles/language.css" scoped></style>
